import { fetchApiJson } from "./apiHelpers";

const API = `${process.env.NEXT_PUBLIC_URL}/linkPageApi`;
const api = (path, method = "GET", body, signal) =>
  fetchApiJson(
    `${API}${path}`,
    {
      method,
      ...(signal ? { signal } : {}),
      ...(body === undefined
        ? {}
        : {
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          }),
    },
    { auth: "required", operation: "Link pages" }
  );

export const listLinkPages = (cursor, signal) =>
  api(
    `/pages${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ""}`,
    "GET",
    undefined,
    signal
  );
export const createLinkPage = (input) => api("/pages", "POST", input);
export const updateLinkPage = (id, input) =>
  api(`/pages/${encodeURIComponent(id)}`, "PATCH", input);
export const deleteLinkPage = (id) =>
  api(`/pages/${encodeURIComponent(id)}`, "DELETE");
export const getLinkPageStats = (id, days, signal) =>
  api(
    `/pages/${encodeURIComponent(id)}/stats?days=${days}`,
    "GET",
    undefined,
    signal
  );
export const getPublicLinkPage = (owner, slug = "", signal) =>
  fetchApiJson(
    `${API}/public/${encodeURIComponent(owner)}${
      slug ? `/${encodeURIComponent(slug)}` : ""
    }`,
    { signal },
    { auth: "none", operation: "Load link page" }
  );
export const resolveShortLink = (code) =>
  fetchApiJson(
    `${API}/resolve/${encodeURIComponent(code)}`,
    {},
    { auth: "none", operation: "Open short link" }
  );
export const trackLinkPageEvent = (id, event) =>
  fetchApiJson(
    `${API}/events/${encodeURIComponent(id)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(event),
      keepalive: true,
    },
    { operation: "Page statistics", skipUnauthorizedHandler: true }
  );

export const getProfileLinkPages = (owner, signal) =>
  fetchApiJson(`${API}/profile/${encodeURIComponent(owner)}`, { signal }, {
    auth: "optional", operation: "Load profile link pages", skipUnauthorizedHandler: true,
  });

export const toggleLinkPageReaction = (id, reaction) =>
  fetchApiJson(
    `${API}/reactions/${encodeURIComponent(id)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reaction),
    },
    { operation: "React", skipUnauthorizedHandler: true }
  );
